import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./MarkSubmissionVisitScreen.css";
import { useCenter } from "../../context/CenterContext";
import { useModerationWindowSession } from "../../constants/Constants";
import { useApi } from "../../context/ApiClient";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";
import { useUnits } from "../../context/UnitsContext";

import { useDashboard } from "../../context/DashboardContext";
const MarkSubmissionVisitScreen = ({ subjectData }) => {
  const moderationWindowSession = useModerationWindowSession();
  const { consortiaUnits = [] } = useUnits()
  const dashboardUnits = useDashboard()?.[subjectData?.selectedSubjectId]?.units || [];
  const navigate = useNavigate();
  const location = useLocation();
  const { centerName, centerNumber } = useCenter();
  const [visitList, setVisitList] = useState([]);
  const [assessmentCriteriaVisitList, setAssessmentCriteriaVisitList] = useState([]);
  const api = useApi(process.env.REACT_APP_AMS_BASE_URL);
  const { consortiaCentres = [] } = useConsortiaCenter();

  const mode = location.state?.mode || "total";
  const getIconColor = (statusColor) => {
    switch (statusColor) {
      case "warning":
        return "#A55900";
      case "info":
        return "#007BFF";
      case "success":
        return "#28A745";
      case "cancel":
        return "#DD1F36";
      case "complete":
        return "#2B8000";
      default:
        return "#767676";
    }
  };

  const ICONS = {
    "Visit Requested":
      "M320-400q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm160 0q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm160 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z",
    "Visit Confirmed":
      "M600-80v-80h160v-400H200v160h-80v-320q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H600ZM320 0l-56-56 103-104H40v-80h327L264-344l56-56 200 200L320 0ZM200-640h560v-80H200v80Zm0 0v-80 80Z",
    "Visit Cancelled":
      "m388-212-56-56 92-92-92-92 56-56 92 92 92-92 56 56-92 92 92 92-56 56-92-92-92 92ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z",
    "Visit Completed":
      "M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z",
  };
  const onClickViewStage3Criteria = (unitName, visitRequestedData,) => {
    const subject = subjectData?.selectedSubject || "subject";
    const subjectSlug = toSlug(subject);
    const unitSlug = toSlug(unitName);

    navigate(
      `/dashboard/ac_update_marks_submission/${subjectSlug}/${unitSlug}`,
      {
        state: {
          unit: unitName,
          sessionStartDate: visitRequestedData.sessionStartDate,
          sessionEndDate: visitRequestedData.sessionEndDate,
          visitDate: visitRequestedData.visitDate,
          statusType: visitRequestedData.statusType,
          sessionId: visitRequestedData.sessionId,
          mode: "view", // view-only for Stage 3 criteria
          additionalVisitDate: visitRequestedData.additionalVisitDate || null,
        },
      },
    );
  };
  const toSlug = (str) =>
    str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");

  const onClickSubmitMarks = (unit, visitRequestedData, type = "", isStage3 = false, isPostStage3 = false) => {

    const subject = subjectData?.selectedSubject || "subject";
    const {
      sessionStartDate,
      sessionEndDate,
      visitDate,
      statusType,
      sessionId,
      additionalVisitDate = null,
    } = visitRequestedData;
    const subjectSlug = toSlug(subject);
    const unitSlug = toSlug(unit);
    if (type === "update") {
      navigate(
        `/dashboard/update_marks_submission/${subjectSlug}/${unitSlug}`,
        {
          state: {
            unit,
            sessionStartDate,
            sessionEndDate,
            visitDate,
            statusType,
            sessionId,
            additionalVisitDate: additionalVisitDate
              ? additionalVisitDate
              : null,
            isStage3,
            isPostStage3
          },
        },
      );
    } else {
      navigate(`/dashboard/marks_submission/${subjectSlug}/${unitSlug}`, {
        state: {
          unit,
          sessionStartDate,
          sessionEndDate,
          visitDate,
          statusType,
          sessionId,
        },
      });
    }
  };

  const onClickSubmitCriteria = (
    unit,
    visitRequestedData,
    isStage3 = false,
    totalMarkStatus = "",
    markStatus = "",
  ) => {
    const subject = subjectData?.selectedSubject || "subject";
    const subjectSlug = toSlug(subject);
    const {
      sessionStartDate,
      sessionEndDate,
      visitDate,
      statusType,
      sessionId,
    } = visitRequestedData;
    const unitSlug = toSlug(unit);
    if (visitRequestedData.statusType === "Visit Confirmed" && !isStage3)
      navigate(`/dashboard/ac_marks_submission/${subjectSlug}/${unitSlug}`, {
        state: {
          unit,
          sessionStartDate,
          sessionEndDate,
          visitDate,
          statusType,
          sessionId,
          mode: "edit",
        },
      });
    else if (visitRequestedData.statusType === "Visit Confirmed" && isStage3)
      navigate(
        `/dashboard/ac_update_marks_submission/${subjectSlug}/${unitSlug}`,
        {
          state: {
            unit,
            sessionStartDate,
            sessionEndDate,
            visitDate,
            statusType,
            sessionId,
            mode: "edit",
            additionalVisitDate: visitRequestedData.additionalVisitDate || null,
            totalMarkStatus,
            markStatus,
          },
        },
      );
  };

  const getSessionDetails = (visits) => {
    const academicYear = `${new Date(
      visits.sessionStartDate,
    ).getFullYear()}/${String(
      new Date(visits.sessionEndDate).getFullYear(),
    ).slice(-2)}`;
    return visits.sessionId === moderationWindowSession.window1
      ? `Window 1 (February series) - ${academicYear}`
      : visits.sessionId === moderationWindowSession.window2
        ? `Window 2 (June series) - ${academicYear}`
        : "";
  };

  const formatAssessmentData = (visitResponse, type, currentCentreType = '') => {
    const data = visitResponse || {};
    const visits = [];

    Object.keys(data).forEach((sessionId) => {
      const assessments = data[sessionId];

      if (assessments && assessments.length > 0) {
        assessments.forEach((a) => {
          const {
            centreNumber,
            subjectId,
            visitStatus,
            moderationType,
            visitDate,
            sessionStartDate,
            sessionEndDate,
          } = a;
          const normalizedVisitStatus =
            visitStatus === "Pending Visit Arrangement"
              ? "Visit Confirmed"
              : visitStatus;
          // Check if a visit with same sessionId + visitStatus + visitDate already exists
          const existingVisit = visits.find(
            (v) =>
              v.sessionId === Number(sessionId) &&
              v.visitStatus === normalizedVisitStatus,
          );

          let assessmentData = {
            assessmentCode: a.assessmentCode,
            assessmentName: a.assessmentName,
            markStatus:
              type === "totalMarks"
                ? a.markStatus
                : a.updatedCriteriaMarkStatus || a.criteriaMarkStatus,
            insertedDate:
              type === "totalMarks"
                ? (a.updatedDate || a.insertedDate)
                : a.updatedCriteriaUpdatedDate || a.updatedCriteriaInsertedDate || (a.criteriaUpdatedDate ? a.criteriaUpdatedDate : a.criteriaInsertedDate),
            isSampled: a.isSampled || null,
            isStage3Sampled: a.isStage3Sampled || null,
            additionalModerationRequired:
              a.additionalModerationRequired || false,
            stage3AdditionalModerationRequired: a.stage3AdditionalModerationRequired || false
          };
          if (["Rest", "Lead"].includes(currentCentreType) && type === "assessmentMarks") {
            assessmentData = {
              ...assessmentData,
              isCandidateExists: a.isCandidateExists || false,
              isStage3CandidateExists: a.isStage3CandidateExists || false
            };
          }

          if (existingVisit) {
            // If it exists, push the assessment into existing array
            existingVisit.assessments.push(assessmentData);
          } else {
            // Otherwise create a new visit entry
            visits.push({
              sessionId: Number(sessionId),
              visitStatus: normalizedVisitStatus,
              moderationType,
              visitDate,
              sessionStartDate,
              sessionEndDate,
              centreNumber,
              subjectId,
              assessments: [assessmentData],
            });
          }
        });
      }
    });

    return visits;
  };

  const formatDate = (input) => {
    if (!input) return "Invalid Date";
    const date = new Date(input.endsWith("Z") ? input : input + "Z");
    if (isNaN(date)) return "Invalid Date";
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  const formatVisitDate = (dateStr) => {
    if (!dateStr) return ""; // or return "N/A", depending on what you want

    const date = new Date(dateStr);
    if (isNaN(date)) return ""; // handle invalid date strings

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const onClickViewMarks = (unit, visitRequestedData, type = "", isPostStage3 = false) => {
    const subject = subjectData?.selectedSubject || "subject";
    const subjectSlug = toSlug(subject);
    const unitSlug = toSlug(unit);
    const {
      sessionStartDate,
      sessionEndDate,
      visitDate,
      additionalVisitDate = null,
      statusType,
      sessionId,
    } = visitRequestedData;
    if (type === "update") {
      navigate(
        `/dashboard/view_update_marks_submission/${subjectSlug}/${unitSlug}`,
        {
          state: {
            unit,
            sessionStartDate,
            sessionEndDate,
            visitDate,
            statusType,
            sessionId,
            additionalVisitDate,
            isPostStage3
          },
        },
      );
    } else {
      navigate(
        `/dashboard/marks_submission-submitted/${subjectSlug}/${unitSlug}`,
        {
          state: {
            unit,
            sessionStartDate,
            sessionEndDate,
            visitDate,
            additionalVisitDate,
            statusType,
            sessionId,
          },
        },
      );
    }
  };

  const onClickViewCriteria = (unitName, visitRequestedData) => {
    const subject = subjectData?.selectedSubject || "subject";
    const subjectSlug = toSlug(subject);
    const unitSlug = toSlug(unitName);

    navigate(`/dashboard/ac_marks_submission/${subjectSlug}/${unitSlug}`, {
      state: {
        ...visitRequestedData,
        unit: unitName,
        mode: "view", //flag for view criteria page
      },
    });
  };
  const currentCentreType =
    getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || "";
  useEffect(() => {
    const fetchAssessmentDetails = async () => {
      try {
        const endpoint =
          ["Lead", "Rest"].includes(currentCentreType)
            ? `consortia/getConsortiaAssessmentList?centreNumber=${centerNumber}&subjectId=${subjectData.selectedSubjectId}`
            : `/getAssessmentList?centreNumber=${centerNumber}&subjectId=${subjectData.selectedSubjectId}`;

        const response = await api.get(endpoint);

        const data = formatAssessmentData(response.data.data, "totalMarks");
        setVisitList(data);
      } catch (err) {
        console.error("Error fetching assessment details:", err);
      }
    };
    fetchAssessmentDetails();
  }, [centerNumber, subjectData.selectedSubjectId]);

  useEffect(() => {
    const fetchCriteriaAssessmentDetails = async () => {
      try {
        const endpoint =
          ["Lead", "Rest"].includes(currentCentreType)
            ? `consortia/getConsortiaAssessmentCriteriaList?centreNumber=${centerNumber}&subjectId=${subjectData.selectedSubjectId}`
            : `/getAssessmentCriteriaList?centreNumber=${centerNumber}&subjectId=${subjectData.selectedSubjectId}`;

        const response = await api.get(endpoint);


        const data = formatAssessmentData(
          response.data.data,
          "assessmentMarks",
          currentCentreType
        );
        setAssessmentCriteriaVisitList(data);
      } catch (err) {
        console.error("Error fetching assessment details:", err);
      }
    };
    if (mode === "criteria") fetchCriteriaAssessmentDetails();
  }, [centerNumber, subjectData.selectedSubjectId]);

  if (!subjectData?.subjectDetails?.isModerationVisit) {
    return (
      <div className="card notification is-info mt-5 mr-5 no-moderation-visit-message">
        <div>You do not have any requested moderation visits.</div>
      </div>
    );
  } else {
    const allVisitsRaw =
      subjectData?.subjectDetails?.visitArrangementResponse || [];
    const statusPriority = {
      "Visit Requested": 1,
      "Visit Confirmed": 2,
      "Visit Completed": 3,
    };
    const getEffectiveDate = (visit) => {
      if (visit.statusType === "Visit Requested") {
        if (visit.preferredDates?.length) {
          // pick the earliest preferred date
          return new Date(
            Math.min(...visit.preferredDates.map((d) => new Date(d).getTime())),
          );
        }
        return null;
      }
      // For confirmed/completed, use visitDate
      return visit.visitDate ? new Date(visit.visitDate) : null;
    };

    const allVisits = [...allVisitsRaw]
      .filter((v) => v.statusType !== "Visit Cancelled")
      .sort((a, b) => {
        const priorityDiff =
          (statusPriority[a.statusType] || 99) -
          (statusPriority[b.statusType] || 99);
        if (priorityDiff !== 0) return priorityDiff;
        return new Date(b.visitDate) - new Date(a.visitDate);
      });
    return (
      <div>
        {allVisits
          .filter((vis) =>
            [
              "Visit Requested",
              "Visit Confirmed",
              "Visit Cancelled",
              "Visit Completed",
            ].includes(vis.statusType),
          )
          .map((visitRequestedData, index) => {
            const { additionalVisitDate = null } = visitRequestedData;

            let markSubmissionStatusData = visitList.find(
              (val) =>
                val.visitStatus === visitRequestedData.statusType &&
                val.sessionId === visitRequestedData.sessionId,
            );
                        if (!visitList.length) {
              return <div className="p-4">Loading visit details...</div>;
            }
            return (
              <div
                key={index}
                className="card notification is-info p-0 mr-5 visits-units-section"
              >
                <div className="p-4 is-flex has-text-dark">
                  <span className="icon mr-2">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      style={{
                        fill:
                          visitRequestedData.statusType === "Visit Requested"
                            ? getIconColor("warning")
                            : visitRequestedData.statusType ===
                              "Visit Confirmed"
                              ? getIconColor("info")
                              : visitRequestedData.statusType ===
                                "Visit Cancelled"
                                ? getIconColor("cancel")
                                : visitRequestedData.statusType ===
                                  "Visit Completed"
                                  ? getIconColor("complete")
                                  : getIconColor(""),
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                    >
                      <path
                        d={
                          ICONS[visitRequestedData.statusType] ||
                          ICONS["Visit Requested"]
                        }
                      />
                    </svg>
                  </span>
                  <div className="is-flex-grow-1">
                    <strong className="visit-date-title">
                      {visitRequestedData.statusType.charAt(0) +
                        visitRequestedData.statusType.slice(1).toLowerCase()}
                      {["visit confirmed", "visit completed"].includes(
                        visitRequestedData.statusType.toLowerCase(),
                      )
                        ? `: ${formatVisitDate(visitRequestedData["visitDate"])}`
                        : ""}
                    </strong>
                    {additionalVisitDate && (
                      <div className="is-flex is-align-items-center">
                        <span className="icon mr-1">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            style={{ fill: "#a55900" }}
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="212121"
                          >
                            <path d="m560-120-57-57 144-143H200v-480h80v400h367L503-544l56-57 241 241-240 240Z" />
                          </svg>
                        </span>
                        <span className="pt-1">
                          <strong style={{ color: "#a55900" }}>
                            {`Additional visit: ${formatDate(
                              additionalVisitDate,
                            )}`}
                          </strong>
                        </span>
                      </div>
                    )}

                    <div className="visit-tags-section">
                      <span className="tag class tags-window">
                        {getSessionDetails(visitRequestedData)}
                      </span>
                      <span className="tag tags-window">
                        {visitRequestedData.moderationType === "Face-to-Face"
                          ? "Face-to-face"
                          : visitRequestedData.moderationType}
                      </span>
                    </div>
                  </div>
                </div>

                <hr className="my-0" />
                <div className="pt-4 has-text-dark px-4 has-background-white">
                  <p className="mb-4 enter-and-submit-text">
                    <strong>For all candidates</strong>
                  </p>
                  {visitRequestedData.assessments.map((val, indx) => {
                    let currentCode = val.split(":")[0];
                    let currentUnitDetails =
                      markSubmissionStatusData?.assessments?.find(
                        (v) => v.assessmentCode === currentCode,
                      ) || {};

                    const {
                      markStatus = "",
                      insertedDate = null,
                      additionalModerationRequired = false,
                      stage3AdditionalModerationRequired = false
                    } = currentUnitDetails || {};
                    const consortiaUnitcode =
                      String(currentCode ?? "")
                        .toUpperCase()
                        .match(/^[A-Z0-9]+/)?.[0] || "";
                    const isConsortiaUnit = checkunitIsConsortiaUnit(
                      consortiaCentres,
                      centerNumber,
                      visitRequestedData.sessionId,
                      consortiaUnitcode,
                    );
                    return (
                      <div key={indx}>
                        <div className="xcard xhas-shadow-1 mb-2">
                          <div className="xcard-head is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap">
                            <div>
                              <div className="is-size-5 has-text-weight-bold">
                                {val.split(":").join(" ")}
                              </div>
                            </div>
                            {/* Stage 3 - Total Marks */}
                            {["Visit Confirmed", "Visit Completed"].includes(visitRequestedData.statusType)
                              &&
                              (additionalModerationRequired || stage3AdditionalModerationRequired ||
                                markStatus === "Re-submitted" || markStatus === "Re-Resubmitted") ? (
                              <div className="is-flex is-align-items-center is-flex-wrap-wrap">
                                {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) &&
                                  <div className="control mr-1 mb-0">
                                    <span className="notification tag is-medium is-warning mb-0 mr-4">
                                      <span className="icon">
                                        <svg
                                          className="mr-2"
                                          style={{ fill: "#A55900" }}
                                          width="16"
                                          height="16"
                                          focusable="false"
                                          aria-hidden="true"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4.00137 20.0099C2.46137 20.0099 1.50137 18.3399 2.27137 17.0099L9.80137 3.99994C10.5714 2.66994 12.4914 2.66994 13.2614 3.99994L20.7914 17.0099C21.5614 18.3399 20.6014 20.0099 19.0614 20.0099H4.00137ZM19.0614 18.0099L11.5314 4.99994L4.00137 18.0099H19.0614Z"
                                          />
                                          <path d="M10.5312 10.01V13C10.5312 13.55 10.9812 14 11.5312 14C12.0812 14 12.5312 13.55 12.5312 13V10.01C12.5312 9.46001 12.0812 9.01001 11.5312 9.01001C10.9812 9.01001 10.5312 9.46001 10.5312 10.01Z" />
                                          <circle cx="11.5312" cy="16.01" r="1" />
                                        </svg>
                                      </span>
                                      {` Additional moderation required`}
                                    </span>
                                  </div>
                                }

                                {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && markStatus && (
                                  <div className="control mr-1 mb-0">
                                    <div className="tags has-addons">
                                      <span
                                        className={`tag is-success ${markStatus === "Saved"
                                          ? "save-color"
                                          : "submit-color"
                                          }`}
                                      >
                                        {markStatus === "Saved"
                                          ? markStatus
                                          : "✔ Total marks updated"}
                                      </span>
                                      <span className="tag is-dark">
                                        {formatDate(insertedDate)}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {["Re-submitted", "Re-Resubmitted"].includes(markStatus) && (
                                  <button
                                    className="button is-text padd-rig mr-0 mb-0"
                                    onClick={() =>
                                      onClickViewMarks(
                                        val.split(":").join(" "),
                                        visitRequestedData,
                                        "update",
                                        stage3AdditionalModerationRequired
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                )}
   
                                  {((!markStatus || markStatus === "Saved") &&
 (currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit))) && (
                                  <button
                                    className="button is-primary submit-button padd-rig mr-0 mb-2"
                                    onClick={() =>
                                      onClickSubmitMarks(
                                        val.split(":").join(" "),
                                        visitRequestedData,
                                        "update",
                                        additionalModerationRequired,
                                        stage3AdditionalModerationRequired
                                      )
                                    }
                                  >
                                    Update total marks
                                  </button>
                                )}
                              </div>
                            ) : (
                              // Stage 1/2 - Total Marks

                              <div className="is-flex is-align-items-center is-flex-wrap-wrap">
                                {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && markStatus && (
                                  <div className="control mr-1 mb-0">
                                    <div className="tags has-addons">
                                      <span
                                        className={`tag is-success ${markStatus === "Saved"
                                          ? "save-color"
                                          : "submit-color"
                                          }`}
                                      >
                                        {markStatus === "Saved"
                                          ? markStatus
                                          : "✔ Total marks submitted"}
                                      </span>
                                      <span className="tag is-dark">
                                        {formatDate(insertedDate)}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {["Submitted", "Re-submitted"].includes(
                                  markStatus,
                                ) && (
                                    <button
                                      className="button is-text padd-rig mr-0 mb-0"
                                      onClick={() =>
                                        onClickViewMarks(
                                          val.split(":").join(" "),
                                          visitRequestedData,
                                        )
                                      }
                                    >
                                      View
                                    </button>
                                  )}

                                {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && (markStatus === "Saved" || !markStatus) &&
                                  visitRequestedData.statusType !==
                                  "Visit Cancelled" && (
                                    <button
                                      className="button is-primary submit-button padd-rig mr-0 mb-2"
                                      onClick={() =>
                                        onClickSubmitMarks(
                                          val.split(":").join(" "),
                                          visitRequestedData,
                                        )
                                      }
                                    >
                                      Submit total marks
                                    </button>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                        {indx < visitRequestedData.assessments.length - 1 && (
                          <hr className="my-2" />
                        )}
                      </div>
                    );
                  })}

                  {mode === "criteria" && (
                    <>
                      <hr className="my-0" />
                      <div className="pt-4 has-text-dark has-background-white">
                        <p className="mb-4 enter-and-submit-text">
                          <strong>For sample candidates</strong>
                        </p>
                        {visitRequestedData.assessments.map((val, indx) => {
                          let assessmentMarkSubmissionStatusData =
                            assessmentCriteriaVisitList.find(
                              (visit) =>
                                visit.visitStatus ===
                                visitRequestedData.statusType &&
                                visit.sessionId ===
                                visitRequestedData.sessionId,
                            );

                          const unitName = val.split(":").join(" ");
                          const currentCode = val.split(":")[0];
                          let currentUnitDetails =
                            assessmentMarkSubmissionStatusData?.assessments?.find(
                              (a) => a.assessmentCode === currentCode,
                            ) || {};
                          const consortiaUnitcode =
                            String(currentCode ?? "")
                              .toUpperCase()
                              .match(/^[A-Z0-9]+/)?.[0] || "";
                          const isConsortiaUnit = checkunitIsConsortiaUnit(
                            consortiaCentres,
                            centerNumber,
                            visitRequestedData.sessionId,
                            consortiaUnitcode,
                          );

                          const {
                            markStatus = "",
                            insertedDate = null,
                            isSampled,
                            isCandidateExists = false,
                            isStage3CandidateExists = false,
                            isStage3Sampled,
                            additionalModerationRequired,
                            stage3AdditionalModerationRequired
                          } = currentUnitDetails || {};
                          //To show the awaiting sample based on the total marks submitted status
                          let currentMarkSubmissionDetails =
                            markSubmissionStatusData?.assessments?.find(
                              (v) => v.assessmentCode === currentCode,
                            ) || {};
                          const totalMarkStatus = (
                            currentMarkSubmissionDetails || {}
                          ).markStatus;
                          const additionalModerationRequiredFromTotalMarks =
                            !!currentMarkSubmissionDetails?.additionalModerationRequired;
                          const stage3AdditionalModerationRequiredFromTotalMarks = !!currentMarkSubmissionDetails?.stage3AdditionalModerationRequired
                          return (
                            <div key={unitName}>
                              <div className="xcard xhas-shadow-1 mb-2">
                                <div className="xcard-head is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap">
                                  <div>
                                    <div className="is-size-5 has-text-weight-bold">
                                      {unitName}
                                    </div>
                                  </div>
                                  {/* Stage 3 - Assessment Criteria Marks */}
                                  {["Visit Confirmed", "Visit Completed"].includes(visitRequestedData.statusType) &&
                                    (additionalModerationRequiredFromTotalMarks || stage3AdditionalModerationRequiredFromTotalMarks ||
                                      totalMarkStatus === "Re-submitted") ? (

                                    <div className="is-flex is-align-items-center is-flex-wrap-wrap">
                                      {isStage3Sampled && (currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && (
                                        <div className="control mr-1 mb-0">
                                          <span className="notification tag is-medium is-warning mb-0 mr-4">
                                            <span className="icon">
                                              <svg
                                                className="mr-2"
                                                style={{ fill: "#A55900" }}
                                                width="16"
                                                height="16"
                                                focusable="false"
                                                aria-hidden="true"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M4.00137 20.0099C2.46137 20.0099 1.50137 18.3399 2.27137 17.0099L9.80137 3.99994C10.5714 2.66994 12.4914 2.66994 13.2614 3.99994L20.7914 17.0099C21.5614 18.3399 20.6014 20.0099 19.0614 20.0099H4.00137ZM19.0614 18.0099L11.5314 4.99994L4.00137 18.0099H19.0614Z"
                                                />
                                                <path d="M10.5312 10.01V13C10.5312 13.55 10.9812 14 11.5312 14C12.0812 14 12.5312 13.55 12.5312 13V10.01C12.5312 9.46001 12.0812 9.01001 11.5312 9.01001C10.9812 9.01001 10.5312 9.46001 10.5312 10.01Z" />
                                                <circle
                                                  cx="11.5312"
                                                  cy="16.01"
                                                  r="1"
                                                />
                                              </svg>
                                            </span>

                                            {` Additional moderation required`}
                                          </span>
                                        </div>
                                      )}
                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && !stage3AdditionalModerationRequiredFromTotalMarks && markStatus &&
                                        markStatus !== "Submitted" && (
                                          <div className="control mr-1 mb-0">
                                            <div className="tags has-addons">
                                              <span
                                                className={`tag is-success ${markStatus === "Saved"
                                                  ? "save-color"
                                                  : "submit-color"
                                                  }`}
                                              >
                                                {markStatus === "Saved"
                                                  ? markStatus
                                                  : markStatus ===
                                                    "Re-submitted"
                                                    ? "✔ Updated criteria marks submitted"
                                                    : ""}
                                              </span>
                                              <span className="tag is-dark">
                                                {formatDate(insertedDate)}
                                              </span>
                                            </div>
                                          </div>
                                        )}

                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && ((!(
                                        visitRequestedData.statusType ===
                                        "Visit Confirmed"
                                      ) &&
                                        totalMarkStatus === "Re-submitted" &&
                                        !isStage3Sampled &&
                                        visitRequestedData.statusType ===
                                        "Visit Confirmed" &&
                                        isStage3Sampled !== false &&
                                        (additionalModerationRequired ||
                                          totalMarkStatus ===
                                          "Re-submitted")) ||
                                        !totalMarkStatus ||
                                        totalMarkStatus === "Saved" ||
                                        (isStage3Sampled &&
                                          markStatus !== "Re-submitted")) && (
                                          <button
                                            className="button is-primary submit-button padd-rig mr-0 mb-2"
                                            disabled={
                                              !totalMarkStatus ||
                                              totalMarkStatus === "Saved" ||
                                              !isStage3Sampled
                                            }
                                            onClick={() =>
                                              onClickSubmitCriteria(
                                                unitName,
                                                visitRequestedData,
                                                true,
                                                markStatus,
                                                totalMarkStatus,
                                              )
                                            }
                                          >
                                            View sample and submit criteria marks
                                          </button>
                                        )}
                                      {!stage3AdditionalModerationRequiredFromTotalMarks && ["Re-submitted"].includes(
                                        markStatus,
                                      )  && (["Rest", "Lead"].includes(currentCentreType) ? isStage3CandidateExists : true)  && (
                                          <button
                                            className="button is-text padd-rig mr-0 mb-0"
                                            onClick={() =>
                                              onClickViewStage3Criteria(
                                                unitName,
                                                visitRequestedData
                                              )
                                            }
                                          >
                                            View
                                          </button>
                                        )}

                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && visitRequestedData.statusType ===
                                        "Visit Confirmed" &&
                                        totalMarkStatus === "Re-submitted" &&
                                        !isStage3Sampled && (
                                          <span className="awaiting-text tag is-light">
                                            Awaiting sample
                                          </span>
                                        )}
                                    </div>
                                  ) : (

                                    // Stage 1/2 -Assessment Criteria Marks
                                    <div className="is-flex is-align-items-center is-flex-wrap-wrap">
                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && markStatus && isSampled !== false && (
                                        <div className="control mr-1 mb-0">
                                          <div className="tags has-addons">
                                            <span
                                              className={`tag is-success ${markStatus === "Saved"
                                                ? "save-color"
                                                : "submit-color"
                                                }`}
                                            >
                                              {markStatus === "Saved"
                                                ? markStatus
                                                : "✔ Criteria marks submitted"}
                                            </span>
                                            <span className="tag is-dark">
                                              {formatDate(insertedDate)}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      { (["Submitted", "Re-submitted"].includes(
                                        markStatus,
                                      ) &&
                                        isSampled) && (["Rest", "Lead"].includes(currentCentreType) ? isCandidateExists : true)  && (
                                          <button
                                            className="button is-text padd-rig mr-0 mb-0"
                                            onClick={() =>
                                              onClickViewCriteria(
                                                unitName,
                                                visitRequestedData,
                                              )
                                            }
                                          >
                                            View
                                          </button>
                                        )}
                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && (["Visit Requested"].includes(
                                        visitRequestedData.statusType,
                                      ) ||
                                        (visitRequestedData.statusType ===
                                          "Visit Confirmed" &&
                                          markStatus !== "Submitted" &&
                                          (!totalMarkStatus ||
                                            totalMarkStatus === "Saved" ||
                                            (totalMarkStatus === "Submitted" &&
                                              isSampled) ||
                                            (totalMarkStatus ===
                                              "Re-submitted" &&
                                              isStage3Sampled)))) && (
                                          <button
                                            className="button is-primary submit-button padd-rig mr-0 mb-2"
                                            onClick={() =>
                                              onClickSubmitCriteria(
                                                unitName,
                                                visitRequestedData,
                                              )
                                            }
                                            disabled={
                                              ["Visit Requested"].includes(
                                                visitRequestedData.statusType,
                                              ) ||
                                              (visitRequestedData.statusType ===
                                                "Visit Confirmed" &&
                                                (!totalMarkStatus ||
                                                  totalMarkStatus === "Saved"))
                                            }
                                            title={
                                              visitRequestedData.statusType ===
                                                "Visit Confirmed" &&
                                                (!totalMarkStatus ||
                                                  totalMarkStatus === "Saved")
                                                ? "You will be unable to submit assessment criteria marks until you have provided an update of total marks."
                                                : ""
                                            }
                                          >
                                            View sample and submit criteria marks
                                          </button>
                                        )}

                                      {(currentCentreType !== 'Rest' || (currentCentreType === 'Rest' && !isConsortiaUnit)) && visitRequestedData.statusType ===
                                        "Visit Confirmed" &&
                                        totalMarkStatus === "Submitted" &&
                                        !isSampled && (
                                          <span className="awaiting-text tag is-light">
                                            Awaiting sample
                                          </span>
                                        )}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {indx <
                                visitRequestedData.assessments.length - 1 && (
                                  <hr className="my-2" />
                                )}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    );
  }
};

export default MarkSubmissionVisitScreen;
